import Component from '../core/Component'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'

export default class PopupNavOpenerHelper extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.openers = []
    }

    prepare() {
        EventBus.on(EVENTS.POPUPNAV_OPENED, this.handlePopupNavOpened)
        EventBus.on(EVENTS.POPUPNAV_CLOSED, this.handlePopupNavClosed)
        EventBus.on(EVENTS.POPUPNAV_CATEGORYCHANGED, this.handlePopupNavCategoryChanged)
        this.attachOpeners()
    }

    destroy() {
        EventBus.off(EVENTS.POPUPNAV_OPENED, this.handlePopupNavOpened)
        EventBus.off(EVENTS.POPUPNAV_CLOSED, this.handlePopupNavClosed)
        EventBus.off(EVENTS.POPUPNAV_CATEGORYCHANGED, this.handlePopupNavCategoryChanged)
    }

    attachOpeners() {
        const openers = [...document.querySelectorAll('[data-popupnav-category]')].map(element => ({
            element,
            categoryId: element.dataset.popupnavCategory,
            action: element.dataset.popupnavAction ?? 'open', // open | toggle
            trigger: element.dataset.popupnavTrigger ?? 'click'
        }))

        const newOpeners = openers.filter(opener => !this.openers.find(oldOpener => oldOpener.element === opener.element))

        newOpeners.forEach(opener => {
            opener.element.addEventListener('click', (event) => this.handleOpenerClick(event, opener))

            opener.element.classList.add('is-ready')
        })
        this.openers.push(...newOpeners)
    }

    handleDomChange = () => {
        this.attachOpeners()
    }

    handleOpenerClick = (event, opener) => {
        event.preventDefault()

        EventBus.emit(EVENTS.POPUPNAV_SETCATEGORY, {
            categoryId: opener.categoryId
        })

        if (opener.action === 'toggle') {
            EventBus.emit(EVENTS.POPUPNAV_TOGGLE)
        } else {
            EventBus.emit(EVENTS.POPUPNAV_OPEN, {
                caller: opener.element
            })
        }
    }

    handlePopupNavOpened = () => {
        document.documentElement.classList.add('is-popup-active')
    }

    handlePopupNavClosed = () => {
        document.documentElement.classList.remove('is-popup-active')
    }

    handlePopupNavCategoryChanged = ({ categoryId }) => {
        this.openers
            .forEach(opener => opener.element.classList.toggle('is-popup-category-active', categoryId && opener.categoryId === categoryId))

        this.attachOpeners()
    }
}